// extracted by mini-css-extract-plugin
module.exports = {"root":"_2xGtl","header":"_93Dgx","link":"_1xBy_","button":"_3F2jz","box":"_2Kyx1","help":"uI_Ze","helpLink":"nV0vb","downloadButtons":"hW1xC"};